(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-paragraph-parallax"] && !Shopify.designMode) return;
  try {
    
(function () {
  var isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  if (isIOS) {
    document.documentElement.classList.add('ios');
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.mobile = window.matchMedia("(max-width:1280px)").matches;
      this.currentURL = window.location.href;
      this.isHp = window.pageType == "index";
      this.header = document.querySelector('.section-header');
      this.stickyHeader = document.querySelector('sticky-header');
      this.animate = this.dataset.animate == "true";
      this.preventAnimation = false;
    }

    init(){
      this.headerBanner = document.querySelector('.banner');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.lastScrollTop = 0;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      //show header with transition at website load

      addEventListener("DOMContentLoaded", (event) => {

        //change header if scroll != 0

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        let scrollLevel = 300;
        this.logoNone = document.querySelector('.logo-selector');
        this.logoScrollNone = document.querySelector('.logo-selector-scroll');
        this.headerHidden = document.querySelector('header');
        this.aboutBreadcrumbs = document.querySelector('.about-breadcrumbs');
      
        if(this.mobile) scrollLevel = 75;

        if (scrollTop > this.currentScrollTop && scrollTop > scrollLevel) {
          this.stickyHeader.classList.add('scrolled-past-header-at-load-not-scroll-top');
          this.stickyHeader.classList.remove('bg-text-color');
          this.stickyHeader.classList.add('scrolled-past-header');
          if (this.logoNone) {
            this.logoNone.classList.add('tw-hidden');
          }
        } else {
          this.stickyHeader.classList.add('scrolled-past-header-at-load'); 
          this.stickyHeader.classList.remove('header-solid'); 
          if (!this.isHp) {
            this.logoScrollNone.classList.remove('tw-hidden');
          } else {
            this.logoScrollNone.classList.add('tw-hidden');
          }
          setTimeout(() => {
            this.headerHidden.classList.add('in-animation');
          }, 600);
        }
      });

      if (!this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.createObserverBanner();
    
    }

    connectedCallback() {
      if(this.isHp){
        this.init();
      }
      else{
        this.header.classList.add('shopify-section-header-sticky');
        document.addEventListener("DOMContentLoaded", ()=>{
          this.stickyHeader.classList.add('scrolled-past-header-at-load-not-scroll-top');
        })
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }
    createObserverBanner() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.bannerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      if (this.headerBanner) observer.observe(this.headerBanner);      
    }

    onScroll() {
      if(this.dataset.animate == "false") return;
      //if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      //let scrollLevel = this.bannerBounds ? this.bannerBounds.bottom - 160 : 400;
      let scrollLevel = 300;
      if(this.mobile) scrollLevel = 75;

      // if (!this.bannerBounds && window.innerWidth < 768) {
      //   scrollLevel = 600;
      // }
      this.logoNone = document.querySelector('.logo-selector');
      this.logoScrollNone = document.querySelector('.logo-selector-scroll');
      this.aboutBreadcrumbs = document.querySelector('.about-breadcrumbs');

      // The scroll is below the threshold, the header has to change from big to small
      if (scrollTop > this.currentScrollTop && scrollTop > scrollLevel) {
        this.stickyHeader.classList.remove('scrolled-up-past-header');
        if (!this.stickyHeader.classList.contains('scrolled-past-header-at-load-not-scroll-top')) {
          this.stickyHeader.classList.add('header-scroll');
        }
        this.stickyHeader.classList.remove('mega-menu-transition');
  
        setTimeout(() => {
          if(!this.preventAnimation){
            this.stickyHeader.classList.add('scrolled-past-header');
            this.headerHidden.classList.remove('tw-py-[1.4rem]');
            this.logoNone.classList.remove('header__heading-logo-animation-show');      
            this.logoNone.classList.add('header__heading-logo-animation-hidden');
            if(this.dataset.transparent === 'false'){
              this.logoNone.parentNode.classList.remove('header__heading-logo-animation-show');
              this.logoNone.closest("a").classList.add('header__heading-logo-animation-hidden');
            }
            this.logoScrollNone.classList.add('header__heading-logo-animation-show');
            // this.stickyHeader.classList.remove('tw-bg-transparent');   
            // this.stickyHeader.classList.add('tw-bg-white');
            this.stickyHeader.classList.add('bg-text-color');
            this.logoNone.classList.add('logo-selector-red');      
            this.logoNone.classList.remove('logo-selector-white');      
            //this.stickyHeader.classList.add('header-solid');    
            // publish(PUB_SUB_EVENTS.closeMegaMenuNoShrink)
            if (this.aboutBreadcrumbs && window.template == 'about') {
              this.aboutBreadcrumbs.classList.remove('tw-hidden');
            }
          }
        }, 250);  
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      }
      // The scroll is above the threshold, the header has to change from small to big
      else if (scrollTop < this.currentScrollTop && scrollTop > scrollLevel) {
        this.stickyHeader.classList.remove('scrolled-up-past-header');
        if (!this.stickyHeader.classList.contains('scrolled-past-header-at-load-not-scroll-top')) {
          this.stickyHeader.classList.add('header-scroll');
        }
        // setTimeout(() => { 
          this.stickyHeader.classList.add('scrolled-past-header');
          // this.headerHidden.classList.remove('tw-py-[1.4rem]');
          this.logoNone.classList.remove('header__heading-logo-animation-show');      
          this.logoNone.classList.add('header__heading-logo-animation-hidden');      
          if(this.dataset.transparent === "false"){
            this.logoNone.parentNode.classList.remove('header__heading-logo-animation-show');      
            this.logoNone.closest("a").classList.add('header__heading-logo-animation-hidden');
          }  
          this.logoScrollNone.classList.add('header__heading-logo-animation-show');
          // this.stickyHeader.classList.remove('tw-bg-transparent');   
          // this.stickyHeader.classList.add('tw-bg-white');
          this.stickyHeader.classList.add('bg-text-color');
          this.logoNone.classList.add('logo-selector-red');       
          //this.stickyHeader.classList.add('header-solid');    
        //}, 250);  
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop < this.currentScrollTop && scrollTop <= this.headerBounds.top) {
          this.preventAnimation = true;
          this.stickyHeader.classList.add('scrolled-up-past-header');
          this.stickyHeader.classList.remove('header-scroll');
          if (this.stickyHeader.classList.contains('scrolled-past-header-at-load-not-scroll-top')) {
            this.stickyHeader.classList.remove('scrolled-past-header-at-load-not-scroll-top');
          }
          //up animation start immediately
          this.stickyHeader.classList.remove('scrolled-past-header');
          this.stickyHeader.classList.remove('bg-text-color');
          //the header change after 250ms
          setTimeout(() => {
            this.logoScrollNone.classList.remove('header__heading-logo-animation-show');     
            this.logoScrollNone.classList.add('header__heading-logo-animation-hidden');
            this.logoNone.parentNode.classList.add('header__heading-logo-animation-show');      
            this.logoNone.parentNode.classList.remove('header__heading-logo-animation-hidden');         
            this.logoNone.classList.add('header__heading-logo-animation-show');
            // this.stickyHeader.classList.add('tw-bg-transparent');   
            // this.stickyHeader.classList.remove('tw-bg-white');
            this.logoNone.classList.remove('logo-selector-red');           
            //this.stickyHeader.classList.remove('header-solid');        
            if (this.aboutBreadcrumbs && window.template == 'about') {
              this.aboutBreadcrumbs.classList.add('tw-hidden');
            }
            this.preventAnimation = false;
          }, 250);
          requestAnimationFrame(this.reset.bind(this));
      }
      // else {
      //   if (scrollTop > this.currentScrollTop && scrollTop > scrollLevel) {
      //     this.stickyHeader.classList.remove('bg-text-color');
      //     this.stickyHeader.classList.remove('overflow-hidden');
      //     this.stickyHeader.classList.remove('tw-max-h-0');
      //     if (this.logoNone) {
      //       this.logoNone.classList.add('tw-hidden');
      //     }
      //   } else {
      //     this.stickyHeader.classList.remove('overflow-hidden');
      //     this.stickyHeader.classList.remove('tw-max-h-0');
      //     this.stickyHeader.classList.remove('tw-max-h-[15.2rem]'); 
      //     this.stickyHeader.classList.remove('header-solid'); 
      //     this.headerHidden.classList.add('tw-opacity-0');
      //     if (!this.isHp) {
      //       this.logoScrollNone.classList.remove('tw-hidden');
      //     } else {
      //       this.logoScrollNone.classList.add('tw-hidden');
      //     }
      //     setTimeout(() => {
      //       this.headerHidden.classList.add('in-animation');
      //     }, 600);
      //   }
      // }
      this.currentScrollTop = scrollTop;
    }


    hide() {
      if (!this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (!this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (!this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();
})();
